function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}

// function getCompany(subject, company) {
//   switch (subject) {
//     case 'legal':
//       return `ЮЛ, ${company.nameLegal}`;
//     case 'physical':
//       return `ФЛ, ${company.lastname} ${company.name && company.name[0]}. `;
//     case 'individ':
//       return company.nameLegal;
//     default:
//       return null;
//   }
// }

const progresses = {};

progresses.default = [
  {
    title: 'Исполнитель',
    name: 'performer',
    fields: [
      'customerType',
      'subject',
      'lastname',
      'name',
      'nameLegal',
      'inn',
      'customerCompany',
    ],

    completed: false,
    check: (values, form) => {
      if (values.customerType === 'new') {
        switch (values.subject) {
          case 'legal':
          case 'individ':
            return !hasErrors(form.getFieldsError(['nameLegal', 'inn'])) &&
              values.nameLegal && values.inn
              ? true
              : false;
          case 'physical':
            return !!(
              !hasErrors(form.getFieldsError(['lastname', 'name'])) &&
              values.lastname && values.name
            );
          default:
            return false;
        }
      } else if (values.customerType === 'select') {
        return (
          !hasErrors(form.getFieldsError(['customerCompany'])) &&
          values.customerCompany
        );
      } else if (values.customerType === 'current') {
        return true;
      }
      return false;
    },
    getDescription: values => {},
  },
  {
    title: 'Контактная информация',
    name: 'contactInfo',
    fields: [],
  },
];

export default progresses;
